var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-autocomplete',_vm._g(_vm._b({attrs:{"value":_vm.value,"name":"timezone","id":"timezone","items":_vm.timezones_as_items(),"update:search-input":"","hide-details":"auto","data-test-id":"timezone-selector"}},'w-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }